export const PREFIX = 'tv3'
export const ADMIN_MASQUERADE_FLAG_KEY = 'is_from_masquerade'
export const USER_STAY_IN_TV3_FLAG_KEY = 'user_stay_in_tv3_v2' // change to v2 to re-trigger the redirection again
export const IGNORE_AUTO_RESPONSE_FLAG_KEY = 'is_ignore_auto_response'
